  // Debug function – kept as is for now
  window.addDebugInfo = (message, category = 'info') => {
    //const debugMessagesContainer = document.getElementById('debug-messages');
    if (!debugMessagesContainer) return;
  
    const timestamp = new Date().toLocaleTimeString();
    const stack = new Error().stack;
    let lineNumber = 'Unknown';
  
    if (stack) {
      const stackLines = stack.split('\n');
      if (stackLines.length >= 3) {
        const callerLine = stackLines[2];
        const regex = /:(\d+):\d+\)?$/;
        const match = callerLine.match(regex);
        if (match?.[1]) {
          lineNumber = match[1];
        }
      }
    }
  
    const messageElement = document.createElement('div');
    messageElement.className = `debug-message debug-${category}`;
    messageElement.innerHTML = `<strong>[${timestamp}] <em>(Line: ${lineNumber})</em> [${category.toUpperCase()}]:</strong> ${message}`;
    debugMessagesContainer.appendChild(messageElement);
  };
  
  class ProductCustomizer {
    constructor() {
      // Core state
      this.container = document.querySelector('[data-product-selector]');
      this.currentStep = 1;
      this.steps = {
        collection: null,
        material: null,
        size: null,
        bandElement: null,
        diamonds: null,
        bandColor: null,
      };
      this.selections = {};
      this.heights = ['small', 'medium', 'large'];
      this.currentHeightIndex = 1;
      this.startY = 0;
      this.maxStep = Object.keys(this.steps).length;
  
      // DOM Elements
      this.customizerHeader = document.querySelector('.customizer-header');
      this.shareMenu = this.customizerHeader?.querySelector('.header-menu-right .share-menu');
      this.leftArrow = document.getElementById('leftArrow');
      this.rightArrow = document.getElementById('rightArrow');
      this.customizerMenu = document.getElementById('customizer-menu');
      this.copyLinkButton = this.customizerMenu?.querySelector('#copy-link-button');
      this.customizerCloseButton = document.getElementById('customizer-close-button');
      this.swipeable = document.getElementById('swipeable');
      this.menuContentContainer = this.swipeable?.querySelector('.menu');
      this.optionsContainer = this.menuContentContainer?.querySelector('.selector-step-container');
      this.minimizeIcon = document.querySelector('.minimize-menu-icon');
      this.maximizeIcon = document.querySelector('.maximize-menu-icon');
      this.closeMenuIcon = document.querySelector('.close-menu-icon');
      this.customizerOrderButton = document.getElementById('customizer-order-button');
  
      // Bound Methods for events
      this.handleMouseUp = this.handleMouseUp.bind(this);
      this.handleSwipe = this.handleSwipe.bind(this);
      this.handleDiamondsSelect = this.handleDiamondsSelect.bind(this);
  
      // New properties
      this.currentProductData = null;
      this.availableProducts = [];
      this.allProducts = [];
      this.currentFilters = {
        collection: null,
        material: null,
        size: null,
        band: null,
        band_color: null,
        diamonds_quantity: null,
        element: null,
      };

      // Save referrer URL in cookie if not already set
      this.originURL = document.referrer ? document.referrer : window.location.origin;
      if (this.originURL && !this.originURL.includes('view=customizer')) {
        this.setReferrerCookie(this.originURL);
      }

      this.init();
    }
  
    init() {
      document.customizer = this;
      this.loadCurrentProductData();
      this.bindEvents();
      this.loadInitialOptions();
      this.initializeDiamondsFilter();
      this.updateBandColorOptions();
      this.setInitialActiveStates();
      this.initializeProductList();
      this.fetchAvailableProducts().then(() => {
        // addDebugInfo('Product data loaded and ready', 'info');
        // Initialize additional handlers here if needed.
      });
    }
  
    loadCurrentProductData() {
  const productJsonElement = document.querySelector('[data-product-json]');
  if (productJsonElement) {
    try {
      this.currentProductData = JSON.parse(productJsonElement.textContent);

      console.log('[ELDUR TEST] current title:', this.currentProductData?.title);
      console.log('[ELDUR TEST] current collection:', this.currentProductData?.metafields?.collection);
      console.log('[ELDUR TEST] current product_collection:', this.currentProductData?.metafields?.product_collection);
      console.log(
        '[ELDUR TEST] all_products count:',
        this.currentProductData?.all_products
          ? Object.keys(this.currentProductData.all_products).length
          : 0
      );

      this.currentFilters.collection = this.currentProductData.metafields.collection;
      this.currentFilters.material = this.currentProductData.metafields.material;
      this.currentFilters.size = this.currentProductData.metafields.size;
      this.currentFilters.band = this.currentProductData.metafields.band;
      this.currentFilters.element = this.currentProductData.metafields.element;
      this.currentFilters.diamonds_quantity = this.currentProductData.metafields.diamonds;
      this.currentFilters.band_color = this.currentProductData.metafields.band_color;
    } catch (error) {
      console.error('[ELDUR TEST] Error parsing product JSON:', error);
    }
  } else {
    console.warn('[ELDUR TEST] [data-product-json] not found');
  }
}
  
    setInitialActiveStates() {
      if (!this.currentProductData) {
        return;
      }
      const metafields = this.currentProductData.metafields || {};
  
      if (metafields.collection) {
        const collectionButtons = this.customizerMenu.querySelectorAll('[data-collection]');
        this.setActiveButton(collectionButtons, metafields.collection);
      }
      if (metafields.material) {
        const materialButtons = this.customizerMenu.querySelectorAll('[data-material]');
        this.setActiveButton(materialButtons, metafields.material);
      }
      if (metafields.size) {
        const sizeButtons = this.customizerMenu.querySelectorAll('[data-size]');
        this.setActiveButton(sizeButtons, metafields.size);
      }
      if (metafields.band) {
        const bandElementButtons = this.customizerMenu.querySelectorAll('[data-band]');
        this.setActiveButton(bandElementButtons, metafields.band);
      }
      if (metafields.element) {
        const bandElementButtons = this.customizerMenu.querySelectorAll('[data-element]');
        this.setActiveButton(bandElementButtons, metafields.element);
      }
      if (metafields.diamonds) {
        const diamondButtons = this.customizerMenu.querySelectorAll('[data-diamonds]');
        this.setActiveButton(diamondButtons, metafields.diamonds);
      }
      if (metafields.band_color) {
        const bandColorButtons = this.customizerMenu.querySelectorAll('[data-band-color]');
        this.setActiveButton(bandColorButtons, metafields.band_color);
      }
    }
  
    /**
     * Sets the active state on the provided button list using the matching value.
     * @param {NodeList} buttons 
     * @param {string} value 
     */
    setActiveButton(buttons, value) {
      if (!buttons || !value) return;
      buttons.forEach((button) => {
        button.classList.remove('active');
        button.dataset.active = 'false';
  
        const buttonValue =
          button.dataset.material ||
          button.dataset.collection ||
          button.dataset.size ||
          button.dataset.band ||
          (button.dataset.element == "" && button.dataset.active === 'true') ||
          button.dataset.diamonds ||
          button.dataset.bandColor;
  
        if (buttonValue && buttonValue.toLowerCase() === value.toString().toLowerCase()) {
          button.classList.add('active');
          button.dataset.active = 'true';
        }
      });
    }
  
    /**
     * Remove filters for steps after the current one.
     * @param {URLSearchParams} params 
     * @returns {URLSearchParams}
     */
    removeFilters(params) {
      const stepKeys = Object.keys(this.steps);
      const currentStepKey = stepKeys[this.currentStep - 1];
  
      stepKeys.forEach((key, index) => {
        if (index > this.currentStep - 1) {
          if (key === 'bandElement') {
            key = 'band';
            this.currentFilters[key] = null;
            this.selections[key] = null;
            key = 'element';
          }
          if (key === 'diamonds') key = 'diamonds_quantity';
  
          this.currentFilters[key] = null;
          this.selections[key] = null;
  
          const filterParamMap = {
            collection: 'collection',
            material: 'gold_color',
            size: 'size',
            diamonds: 'diamonds_quantity',
            band_color: 'band_color',
            band: 'bracelet_size',
            element: 'elements',
          };
          const filterParam = filterParamMap[key] || key;
          params.delete(`filter.p.m.${filterParam}`);
        }
      });
      return params;
    }
  
    /**
     * Get the variant link for the current product
     * @returns {string}
     */
    getVariantLink(customizerUrl = true) {
        try { 
          let productData = this.currentProductData;
          if (productData.variant) {
            productData = productData.variant;
          }
          const sku = productData.sku.replace(/-[0-9]+$/, '');
          let variantUrl = null;
          if(customizerUrl) {
            variantUrl = new URL(
              `/collections/customizer-collection?view=customizer&product=${sku}&variant=${productData.id}`,
              window.location.origin
            );
          } else {
            variantUrl = new URL(
              `/products/${sku}?variant=${productData.id}`,
              window.location.origin
            );
          }
          return variantUrl.href;
        } catch (error) {
          alert("Error: Can't get Link for selected Product");
          return "#";
        }
    }

    bindEvents() {
      // Close Share Menu not clicked on a button
      document.body.addEventListener('click', (e) => {
        // Check if the click target is not a button and not inside the customizer menu
        if(!document.querySelector('.menu-share').classList.contains('nodisplay')) {
          if (!e.target.closest('image-buttons') && !e.target.closest('button') && !e.target.closest('a')) {
            this.toggleShareMenu();
          }
        }
      });

      if (this.shareMenu) {
        this.shareMenu.addEventListener('click', () => this.toggleShareMenu());
      }

      if (this.customizerCloseButton) {
        this.customizerCloseButton.addEventListener('click', () => window.location.href = this.originURL);
      }
  
      if (this.copyLinkButton) {
        this.copyLinkButton.addEventListener('click', async (e) => {
          const customizerUrl = this.getVariantLink();
          const feedbackElement = this.copyLinkButton.querySelector('.copy-feedback');
  
          try {
            await navigator.clipboard.writeText(customizerUrl);
            this.showFeedback(this.copyLinkButton, feedbackElement, 'Customized product link copied!', 'success');
          } catch (err) {
            this.showFeedback(this.copyLinkButton, feedbackElement, 'Failed to copy link', 'error');
            console.error('Failed to copy:', err);
          }
        });
      }

      if (this.customizerOrderButton) {
        this.customizerOrderButton.addEventListener('click', () => {
            this.customizerOrderButton.href = this.getVariantLink(false);
        });
      }
  
      if (this.leftArrow) {
        this.leftArrow.addEventListener('click', () => {
            if (this.currentStep > 1) {
                this.currentStep--;
                const stepKeys = Object.keys(this.steps);
                const currentStepKey = stepKeys[this.currentStep - 1];

                const url = new URL(window.location.href);
                let params = new URLSearchParams(url.search);
                //params = this.removeFilters(params);
                url.search = params.toString();
                // window.history.pushState({}, '', url.toString());

                this.updateUI();
            
                // Recalculate available options for the next step (if one exists).
                if (this.currentStep < this.maxStep) {
                    // re-enable all options for the next step
                    // reset currentFilters attribute
                    const matchingProducts = this.currentProductData.all_products.filter((product) => {
                        return Object.entries(this.currentFilters).every(([key, val]) => {
                            if (!val) return true;
                            // Use the normalized key for diamonds
                            const normalizedKey = key === 'diamonds_quantity' ? 'diamonds' : key;
                            return product.metafields[normalizedKey]?.toString().toLowerCase() ===
                                val.toString().toLowerCase();
                        });
                    });

                    this.updateAvailableOptions(matchingProducts);
                }
            }
        });
      }
  
      if (this.rightArrow) {
        this.rightArrow.addEventListener('click', () => {
          let stepKeys = Object.keys(this.steps);
          let currentStepKey = stepKeys[this.currentStep - 1];
          if (this.currentStep === 1) {
            this.handleCollectionSelection(
              this.customizerMenu.querySelector('.collection-option.active')
            )
          } else if (this.currentStep < this.maxStep) {  
            if (currentStepKey === 'bandElement') {
              currentStepKey = 'band';
              this.autoChooseOption(currentStepKey);
              currentStepKey = 'element';
            }
            if (!this.selections[currentStepKey]) {
              this.autoChooseOption(currentStepKey);
            }
          }
          this.currentStep++;
          this.updateUI();
        });
      }
  
      if (this.swipeable) {
        this.swipeable.addEventListener('touchstart', (e) => {
          this.startY = e.touches[0].clientY;
        });
        this.swipeable.addEventListener('touchend', (e) => {
          const endY = e.changedTouches[0].clientY;
          this.handleSwipe(this.startY, endY);
        });
        this.swipeable.addEventListener('mousedown', (e) => {
          this.startY = e.clientY;
          document.addEventListener('mouseup', this.handleMouseUp);
        });
      }
  
      this.customizerMenu.querySelectorAll('button.collection-option').forEach((button) =>
        button.addEventListener('click', (e) => this.handleCollectionSelect(e))
      );
  
      this.customizerMenu?.querySelectorAll('.diamonds-option').forEach((button) =>
        button.addEventListener('click', (e) => this.handleDiamondsSelect(e))
      );
  
      this.customizerMenu.querySelectorAll('button.material-option').forEach((button) =>
        button.addEventListener('click', (e) => this.handleMaterialSelection(e))
      );
  
      this.customizerMenu.querySelectorAll('.size-option').forEach((button) =>
        button.addEventListener('click', (e) => this.handleSizeSelection(e))
      );
  
      this.customizerMenu.querySelectorAll('.band-option').forEach((button) =>
        button.addEventListener('click', (e) => this.handleBandOptionSelection(e))
      );
  
      this.customizerMenu.querySelectorAll('.element-option').forEach((button) =>
        button.addEventListener('click', (e) => this.handleBandElementSelection(e))
      );
  
      this.customizerMenu.querySelectorAll('.band-color-option').forEach((button) =>
        button.addEventListener('click', (e) => this.handleBandColorSelection(e))
      );
  
      // Debug toggle functionality
      const toggleDebugBtn = document.getElementById('toggle-debug-btn');
      const debugInfo = document.getElementById('debug-info');
      const clearDebugInternal = document.getElementById('clear-debug-internal');
      const debugMessages = document.getElementById('debug-messages');
  
      if (toggleDebugBtn) {
        toggleDebugBtn.addEventListener('click', () => {
          debugInfo.style.display = debugInfo.style.display === 'none' ? 'block' : 'none';
        });
      }
  
      if (clearDebugInternal) {
        const clearDebug = () => {
          if (debugMessages) {
            debugMessages.innerHTML = '';
          }
        };
        clearDebugInternal.addEventListener('click', clearDebug);
      }
  
      if (this.minimizeIcon) {
        this.minimizeIcon.addEventListener('click', () => this.handleMinimizeClick());
      }
  
      if (this.maximizeIcon) {
        this.maximizeIcon.addEventListener('click', () => this.handleMaximizeClick());
      }
  
      if (this.closeMenuIcon) {
        this.closeMenuIcon.addEventListener('click', () => this.handleCloseMenuClick());
      }
    }
  
    /**
     * Automatically choose an option for a given step if none was selected.
     * @param {string} currentStepKey 
     */
    autoChooseOption(currentStepKey) {
      const activeButton = this.customizerMenu.querySelector(`.${currentStepKey}-option.active`);
      if (activeButton) {
        if(currentStepKey !== 'element') {
          activeButton.click();
        }
      }
    }
  
    handleMouseUp(e) {
      this.handleSwipe(this.startY, e.clientY);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }
  
    handleSwipe(startY, endY) {
      this.swipeable.classList.remove(`swipeable-${this.heights[this.currentHeightIndex]}`);
      if (startY > endY + 20 && this.currentHeightIndex < this.heights.length - 1) {
        this.currentHeightIndex++;
      } else if (startY < endY - 20 && this.currentHeightIndex > 0) {
        this.currentHeightIndex--;
      }
      this.updateMenuState();
    }
  
    updateMenuState() {
      const SirvElement = document.querySelector('div.Sirv');
      if (this.swipeable.classList.contains('share')) return;
  
      this.swipeable.classList.add(`swipeable-${this.heights[this.currentHeightIndex]}`);
  
      switch (this.currentHeightIndex) {
        case 0: {
          const menuLarge = this.swipeable.querySelector('.menu-large');
          menuLarge.classList.add('nodisplay');
          this.swipeable.querySelector('.menu').classList.remove('nodisplay');
          this.swipeable.classList.add('menu-small');
          this.swipeable.classList.remove('menu-medium');
          this.swipeable.classList.remove('menu-large');
          this.menuContentContainer.classList.remove('swipeable-medium');
          this.menuContentContainer.classList.add('swipeable-small');
          this.optionsContainer.classList.add('nodisplay');
          if (SirvElement) {
            SirvElement.classList.remove('minimized');
            SirvElement.classList.add('maximized');
          }
          break;
        }
        case 1: {
          const menuLarge = this.swipeable.querySelector('.menu-large');
          menuLarge.classList.add('nodisplay');
          this.swipeable.querySelector('.menu').classList.remove('nodisplay');
          this.swipeable.classList.remove('menu-small');
          this.swipeable.classList.add('menu-medium');
          this.swipeable.classList.remove('menu-large');
          this.menuContentContainer.classList.add('swipeable-medium');
          this.menuContentContainer.classList.remove('swipeable-small');
          this.optionsContainer.classList.remove('nodisplay');
          if (SirvElement) {
            SirvElement.classList.remove('maximized');
            SirvElement.classList.remove('minimized');
          }
          break;
        }
        case 2: {
          const menuLarge = this.swipeable.querySelector('.menu-large');
          menuLarge.querySelector('#collection-name-large').textContent = this.currentProductData.metafields.collection;
          const goldGradient = this.currentProductData.metafields.material.toLowerCase().replace(/\s.*/g, '');
          const materialValueLarge = menuLarge.querySelector('#material-value-large');
          materialValueLarge.className = materialValueLarge.className.replace(/([a-z]+)(-gradient)/, `${goldGradient}$2`);
          menuLarge.querySelector('#size-value-large').textContent = this.currentProductData.metafields.size;
          menuLarge.querySelector('#band-value-large').textContent = this.currentProductData.metafields.band;
          menuLarge.querySelector('#element-value-large').textContent = this.currentProductData.metafields.element
            ? 'with additional pieces'
            : 'without additional pieces';
          menuLarge.querySelector('#diamonds-value-large').textContent = this.currentProductData.metafields.diamonds;
          if (this.currentProductData.variant) {
            menuLarge.querySelector('#band-color-value-large').textContent =
              document.querySelector('.swipeable-medium .band-color-option.active')?.dataset.bandColor;
          }
          menuLarge.classList.remove('nodisplay');
          this.swipeable.querySelector('.menu').classList.add('nodisplay');
          this.swipeable.classList.remove('menu-small');
          this.swipeable.classList.remove('menu-medium');
          this.swipeable.classList.add('menu-large');
          this.menuContentContainer.classList.add('swipeable-medium');
          this.menuContentContainer.classList.remove('swipeable-small');
          this.optionsContainer.classList.remove('nodisplay');
          if (SirvElement) {
            SirvElement.classList.add('minimized');
            SirvElement.classList.remove('maximized');
          }
          break;
        }
      }
    }
  
    toggleShareMenu() {

      if (this.swipeable.classList.contains('share')) {
        // hide share menu
        this.swipeable.querySelector('.menu-share').classList.add('nodisplay');
        this.swipeable.classList.remove('share');
        this.swipeable.classList.add(`swipeable-${this.heights[this.currentHeightIndex]}`);
        this.swipeable.querySelector('.menu-container').classList.remove('nodisplay');
        document.querySelector('div.Sirv').style.filter = '';
      } else {
        // show share menu
        document.querySelector('div.Sirv').style.filter = 'blur(6px)';
        this.swipeable.querySelector('.menu-share').classList.remove('nodisplay');
        this.swipeable.classList.add('share');
        this.swipeable.classList.remove(`swipeable-${this.heights[this.currentHeightIndex]}`);
        this.swipeable.classList.remove('menu-small');
        this.swipeable.classList.remove('menu-medium');
        this.swipeable.classList.remove('menu-large');
        this.swipeable.querySelector('.menu-container').classList.add('nodisplay');
      }
    }
  
    /**
     * Displays a feedback message on an element then resets its state.
     * @param {HTMLElement} button 
     * @param {HTMLElement} feedbackElement 
     * @param {string} message 
     * @param {string} btnToggleClass 
     */
    showFeedback(button, feedbackElement, message, btnToggleClass = 'copied') {
      button.classList.add(btnToggleClass);
      feedbackElement.querySelector('.feedback-message').textContent = message;
      feedbackElement.classList.remove('nodisplay');
  
      setTimeout(() => {
        button.classList.remove(btnToggleClass);
        feedbackElement.classList.add('nodisplay');
      }, 2000);
    }
  
    handleCollectionSelect(e) {
      const button = e.currentTarget.closest('.collection-option');
      if (!button || button.disabled || button.classList.contains('active')) return;
      this.showCollectionChangeModal(button);
    }
  
    getAvailableOptions(key) {
      const availableOptions = { [key]: [] };
      const filters = this.currentFilters;
      if (filters && filters[key]) {
        availableOptions[key] = filters[key];
      } else {
        const allOptions = this.cache.get('products');
        const keyOptions = allOptions[key]?.values || [];
        keyOptions.forEach((value) => availableOptions[key].push(value));
      }
      return availableOptions;
    }
  
    updateAvailableOptions(matchingProducts) {
      // Get the current step key from steps
      let currentStep = Object.keys(this.steps)[this.currentStep - 1];
      const filters = this.cache.get('filters');
      
      // Fix diamond filter key mismatch: if we're on the diamond step and no filter exists under 'diamonds', try 'diamonds_quantity'
      if (currentStep === 'diamonds' && filters && !filters[currentStep] && filters['diamonds_quantity']) {
        currentStep = 'diamonds_quantity';
      }

      // Special handling for diamonds step
      if (currentStep === 'diamonds' || currentStep === 'diamonds_quantity') {
        this.updateDiamondsOptions(matchingProducts);
        /* return;*/
      }

      if (filters && filters[currentStep]) {
        const filterGroup = filters[currentStep];
        // For diamond options, the HTML uses the data attribute 'data-diamonds', so map accordingly
        const visibilityKey = (currentStep === 'diamonds_quantity') ? 'diamonds' : currentStep;

        this.updateOptionVisibility(visibilityKey, filterGroup.values, filterGroup.disabledValues);
      }

      if (matchingProducts?.length > 0) {
        const nextStep = Object.keys(this.steps)[this.currentStep];
        this.updateNextStepOptions(matchingProducts, nextStep);
      }
    }
  
    // New method to specifically handle diamond options
    updateDiamondsOptions(matchingProducts) {
      if (!matchingProducts || matchingProducts.length === 0) {
        return;
      }

      // Extract all available diamond quantities from matching products
      let availableDiamondQuantities = [];
      
      // Always include "0" (None) as an option
      availableDiamondQuantities.push("0");
      
      // Add diamond quantities from matching products
      matchingProducts.forEach(product => {
        if (product.metafields && product.metafields.diamonds) {
          const diamondQuantity = product.metafields.diamonds.toString();
          if (!availableDiamondQuantities.includes(diamondQuantity)) {
            availableDiamondQuantities.push(diamondQuantity);
          }
        }
      });
      
      // Update the UI to show only available diamond options
      const diamondButtons = this.customizerMenu.querySelectorAll('.diamonds-option');
      diamondButtons.forEach(button => {
        const diamondValue = button.dataset.diamonds;
        const isAvailable = availableDiamondQuantities.includes(diamondValue);
        
        // Update button state
        if (!isAvailable) {
          button.classList.add('disabled');
          button.disabled = true;
        } else {
          button.classList.remove('disabled');
          button.disabled = false;
        }        
        
      });
    }
  
    updateNextStepOptions(matchingProducts, stepName) {
      if (stepName === 'bandElement') {
        this.updateSingleAttributeOptions(matchingProducts, 'band');
        this.updateSingleAttributeOptions(matchingProducts, 'element');  
        return;
      }
      this.updateSingleAttributeOptions(matchingProducts, stepName);
    }
  
    updateSingleAttributeOptions(matchingProducts, attributeName) {
      let stepName = attributeName;
      if (attributeName === 'bandColor') stepName = 'band-color';
      const stepOptions = document.querySelectorAll(`.${stepName}-option`);

      let current_option = undefined;
      
      // Error: we need to get the current products value - Get the current option from the first matching product only, if no product available
      current_option = this.currentProductData?.metafields?.[attributeName];
      if (current_option === undefined) {
        // fallback to select an option
        current_option = matchingProducts[0].metafields?.[attributeName];
      }
      
      // Special handling for band-color
      if (attributeName === 'band-color') {
        current_option = this.currentProductData.variant.title.toLowerCase();
        if (current_option === undefined)
          current_option = this.currentProductData.title.toLowerCase();
      }
      
      // Special handling for band - preserve the current band value if it exists
      if (attributeName === 'band' && this.currentFilters.band) {
        current_option = this.currentFilters.band;
      }
      
      if (attributeName === 'bandColor') {
        this.checkVariantOptions(attributeName, stepOptions, this.currentProductData.variant.title.toLowerCase());
        return;
      }
      // set boolean state
      if (stepOptions.length === 1) {
        let allOptions = matchingProducts.map((product) => product.metafields?.[attributeName]); //should be 1 item
        let uniqueOptions = [...new Set(allOptions)]; // should be true and false
        this.updateOptionState(stepOptions[0], true, this.currentProductData.metafields?.[attributeName], uniqueOptions.length > 1);
        return;
      }
      stepOptions.forEach((option) => {
        let optionValue = option.dataset[attributeName];
        let isAvailable = matchingProducts.some((product) => {
          let productOption = product.metafields?.[attributeName];
          if (productOption === undefined)
            productOption = product.variant.title.toLowerCase();
          if (typeof productOption === 'string' || typeof productOption === 'number') {
            productOption = productOption.toString().toLowerCase();
            optionValue = optionValue.toString().toLowerCase();
            if (current_option !== undefined) current_option = current_option.toString().toLowerCase();
            if( productOption === optionValue) {
              // TODO: the variant has to be set by color
              option.dataset.productSku = product.variants.find(variant => 
                variant.title && variant.title.toLowerCase().includes(this.currentFilters.band_color?.toLowerCase()))?.sku;
              if(attributeName === 'band-color') {
                option.dataset.productId = product.variant?.id;
              }
              // product sku is set correct, sirv image is always large on size
              return true;
            }
          }
          return false;
        });
        this.updateOptionState(option, optionValue, current_option, isAvailable);
      });
    }
  
    checkVariantOptions(attributeName, stepOptions, current_option) {
      const availableOptions = this.currentProductData.variants.map((variant) =>
        variant.title.toLowerCase().replace(/\s+/g, '-')
      );
      stepOptions.forEach((option) => {
        const optionValue = option.dataset[attributeName];
        const isAvailable = availableOptions.includes(optionValue.toLowerCase());
        this.updateOptionState(option, optionValue, current_option, isAvailable);
      });
    }
  
    updateOptionState(option, optionValue, currentValue, isAvailable) {
      if (optionValue === currentValue) {
        option.classList.add('active');
        option.dataset.active = 'true';
      } else {
        option.classList.remove('active');
        option.dataset.active = 'false';
      }
      if (!isAvailable) {
        option.classList.add('disabled');
        option.disabled = true;
      } else {
        option.classList.remove('disabled');
        option.disabled = false;
      }
    }
  
    updateOptionVisibility(type, available, disabled = []) {
      const buttons = this.customizerMenu.querySelectorAll(`[data-${type}]`);
      buttons.forEach((btn) => {
        const value = btn.dataset[type];
        
        /*
        // Special handling for band options - never hide "Double" band option
        if (type === 'band' && value.toLowerCase() === 'double') {
          btn.classList.remove('hide');
          btn.classList.remove('disabled');
          btn.disabled = false;
          btn.classList.add('available');
          // addDebugInfo('Ensuring Double band option remains available', 'info');
          return;
        }
        */
        
        // Handle explicitly disabled options (hide them)
        if (disabled.includes(value)) {
          btn.classList.add('disabled');
          btn.classList.add('hide');
          btn.disabled = true;
        } else {
          btn.classList.remove('hide');
          
          // Handle availability - if not available, disable but don't hide
          if (!available.includes(value)) {
            btn.classList.add('disabled');
            btn.disabled = true;
            btn.classList.remove('available');
          } else {
            btn.classList.remove('disabled');
            btn.disabled = false;
            btn.classList.add('available');
          }
        }
      });
    }

    updateUI() {
      this.customizerMenu.querySelectorAll('.selector-step').forEach((step) => {
        const stepNum = parseInt(step.dataset.step, 10);
        step.classList.toggle('active', stepNum === this.currentStep);
        if (stepNum === this.currentStep) {
          this.customizerMenu.querySelector('#customizer-step-headline').textContent = `${step.dataset.stepName} ${this.currentStep}/6`;
        }
        this.leftArrow.classList.toggle('hide', this.currentStep === 1);
        this.rightArrow.classList.toggle('hide', this.currentStep === this.maxStep);
      });
      
      // Handle diamonds selector visibility
      const diamondsSelector = this.customizerMenu.querySelector('.diamonds-selector');
      if (diamondsSelector) {
        diamondsSelector.style.display = this.currentStep === 5 ? 'block' : 'none';
      }
      
      // If we're on the diamonds step, update available diamond options
      if (this.currentStep === 5) {
        // Get current filters excluding diamonds
        const currentFilters = {
          collection: this.currentFilters.collection,
          material: this.currentFilters.material,
          size: this.currentFilters.size,
          band: this.currentFilters.band,
          band_color: this.currentFilters.band_color,
          element: this.currentFilters.element
        };
        
        // Find matching products based on current filters (excluding diamonds)
        if (this.currentProductData && this.currentProductData.all_products) {
          const matchingProducts = this.currentProductData.all_products.filter(product => {
            return Object.entries(currentFilters).every(([key, val]) => {
              if (!val) return true;
              const normalizedKey = key === 'diamonds_quantity' ? 'diamonds' : key;
              return product.metafields[normalizedKey]?.toString().toLowerCase() === 
                    val.toString().toLowerCase();
            });
          });
          
          // Update diamond options based on matching products
          this.updateDiamondsOptions(matchingProducts);
        }
      }
    }
  
    finalizeSelection() {
      const selectedProduct = this.findMatchingProduct();
      if (selectedProduct) {
        window.location.href = `/products/${selectedProduct.handle}`;
      }
    }
  
    parseFilters() {
      const filterData = document.getElementById('collection-filter-data');
      if (!filterData) {
        return {};
      }
      let filterGroups = {};
      try {
        if (filterData.dataset.filterGroups) {
          filterGroups = JSON.parse(decodeURIComponent(filterData.dataset.filterGroups));
        } else {
          filterGroups = JSON.parse(filterData.textContent);
        }
        const processedFilters = {};
        for (const [key, filter] of Object.entries(filterGroups)) {
          processedFilters[key] = {
            label: filter.label,
            values: filter.values,
            activeValues: filter.values.filter((v) => v.active).map((v) => v.value),
            disabledValues: filter.values.filter((v) => v.count === 0 && !v.active).map((v) => v.value),
          };
        }
        return processedFilters;
      } catch (error) {
        console.error('JSON Parsing Error:', error);
      }
      return filterGroups;
    }
  
    showCollectionChangeModal(selectedButton) {
      const collectionName = selectedButton.dataset.collection;

      const modalTemplate = document.getElementById('collection-change-modal-template');
      const modal = modalTemplate.content.cloneNode(true).firstElementChild;
      document.body.appendChild(modal);

      const collectionSpan = modal.querySelector('.selected-collection');
      if (collectionSpan) {
        collectionSpan.textContent = collectionName;
      }
      const switchBtn = modal.querySelector('.switch-collection');
      const keepBtn = modal.querySelector('.keep-customizing');
  
      switchBtn.addEventListener('click', () => {
        this.handleCollectionSelection(selectedButton, true);
        document.body.removeChild(modal);
      });
      keepBtn.addEventListener('click', () => {
        document.body.removeChild(modal);
      });
    }
  
    handleCollectionSelection(selectedButton, reset = false) {
      this.customizerMenu.querySelectorAll('.collection-option').forEach((btn) => {
        btn.classList.remove('active');
        btn.dataset.active = 'false';
      });
      selectedButton.classList.add('active');
      selectedButton.dataset.active = 'true';

      // Store the current band value before resetting selections
      const currentBand = this.currentProductData.metafields.band;
      
      this.selections = {};
      this.currentStep = 1;
      const collectionName = selectedButton.dataset.collection;
      this.selections.collection = collectionName;
      // if we come without a defined product
      let filteredProduct = null;
      if(this.currentFilters.collection === undefined || reset) {
        this.currentFilters = {
          collection: collectionName,
          material: null,
          size: null,
          band: null, // Preserve the current band value
          band_color: null,
          diamonds_quantity: null,
          element: null
        };
        
        let defaultVariantsContent = document.getElementById('default-variants')?.text;
        this.defaultVariants = [];
        if (defaultVariantsContent.length > 0) {
          this.defaultVariants = JSON.parse(defaultVariantsContent);
          this.defaultVariants = this.defaultVariants.map((variant) => {
            // Find the position of the last '/' in the variant string
            let lastSlashIndex = variant.lastIndexOf('/');
            // Return the substring after the last '/' if found, otherwise return the original variant
            return lastSlashIndex !== -1 ? variant.substring(lastSlashIndex + 1) : variant;
          });
        }

        try {
          filteredProduct = this?.allProducts?.find((product) => {
            if(product.metafields?.collection.toLowerCase() == collectionName.toLowerCase()) {
                let productVariant = this.getProductVariant(product);
                product.variant = productVariant;
                if (productVariant !== undefined) return product;
            }
          });
        } catch (error) {
          console.log('error setting collection default variant: ', error);
          filteredProduct = null;
        }
      }
      // fallback to filter if we have no predefined variants
      if(filteredProduct == null) {
        filteredProduct = this.getProductByFilters(this.currentFilters);
      }
      
      if (filteredProduct) {
        this.currentProductData = filteredProduct;
        this.currentFilters.band_color = this.currentProductData.variant.title.toLowerCase();
        // IMPORTANT: updateImages now extracts the variant from the product
        this.updateProductNamePrice(collectionName, this.currentProductData.variant?.price);
        this.updateImages(filteredProduct);
        this.updateProductOptions('collection', collectionName);
      }
      this.updateUI();
    }
  
    /**
     * if no field is specified, returns default variant if available
     * @param {*} product a product object
     * @param {*} fieldName 
     * @param {*} fieldValue 
     * @returns 
     */
    getProductVariant(product, fieldName, fieldValue) {
      let variant = product.variants.find((variant) => {
        if (fieldName !== undefined) {
          if (variant[fieldName] == fieldValue) {
            return variant;
          }
        } else {
          for (let i = 0; i < this.defaultVariants.length; i++) {
            if (this.defaultVariants[i] == variant.id) {
              return variant;
            }
          }
        }
      });
      return variant;
    }

    handleMaterialSelection(event) {
      const button = event.currentTarget.closest('.material-option');
      if (!button || button.disabled) return;
  
      const material = button.dataset.material;
      this.selections.material = material;
      this.currentStep = 2;
  
      this.customizerMenu.querySelectorAll('.material-option').forEach((btn) => {
        btn.classList.remove('active');
        btn.dataset.active = 'false';
      });
  
      button.classList.add('active');
      button.dataset.active = 'true';
  
      this.currentFilters = { ...this.currentFilters, material: material };
      const filteredProduct = this.getProductByFilters(this.currentFilters);
      this.currentProductData = filteredProduct;
      this.updateProductOptions('material', material);
      this.updateProductNamePrice(null, this.currentProductData.variant?.price);
      this.updateImages(filteredProduct);
    }
  
    /**
     * Updates images based on the product.
     * Note: This method now extracts the variant from the product (via product.variant)
     * before calling changeSpin and updateShareMenuImage.
     * @param {Object} product 
     */
    updateImages(product) {
      const variant = product.variant || product;
      this.changeSpin(variant);
      this.updateShareMenuImage(variant);
      this.compareFilteredProductsWithCurrentProduct();
    }
  
    getProductByFilters(filters) {
      let allProducts = this.allProducts;
      
      // Define the filter criteria we're checking
      const filterCriteria = [
        { key: 'collection', required: true, filter_score: 6 },
        { key: 'material', required: false, filter_score: 5 }, // gold
        { key: 'size', required: false, filter_score: 4 }, // s,m,l
        { key: 'band', required: false, filter_score: 3 }, // single/double
        { key: 'element', required: false, filter_score: 2 }, // additional Elements
        { key: 'band_color', required: false, filter_score: 0 },
        { key: 'diamonds_quantity', required: false, filter_score: 1 },
      ];

      for( let filter in this.currentFilters) {        
        if (this.currentFilters[filter] == null) {
          let value = this.currentProductData.metafields[filter];
          if (filter == 'diamonds_quantity') value = this.currentProductData.metafields.diamonds;
          this.currentFilters[filter] = value;
        }
      }
      
      // Calculate a score for each product based on how many criteria it matches
      let scoredProducts = allProducts.map(product => {
        let score = 0;
        let matchDetails = {};
        let allRequiredMatch = true; // Track if all required fields match
        let maxScore = 0;

        // Check each filter criterion
        filterCriteria.forEach(criterion => {
          const key = criterion.key;
          const required = criterion.required;
          let isMatch = false;
          maxScore += criterion.filter_score;
          
          // Skip if filter is not provided
          if (!(key in filters)) {
            isMatch = true;
          } 
          else if (typeof filters[key] === 'boolean') {
            if (product.metafields[key] === 'undefined')
              product.metafields[key] = false;
            isMatch = filters[key] === product.metafields[key];
          }
          // Special handling for diamonds_quantity - must be an exact match
          else if (key === 'diamonds_quantity') {
            // Get the product's diamonds value, ensuring it's a number
            let productDiamonds;
            if (product.metafields && product.metafields.diamonds !== undefined) {
              // Try to parse as integer, default to 0 if not a valid number
              productDiamonds = parseInt(product.metafields.diamonds);
              if (isNaN(productDiamonds)) productDiamonds = 0;
            } else {
              productDiamonds = 0;
            }
            
            // Get the filter's diamonds value, ensuring it's a number
            let filterDiamonds;
            if (filters[key] !== undefined) {
              // Try to parse as integer, default to 0 if not a valid number
              filterDiamonds = parseInt(filters[key]);
              if (isNaN(filterDiamonds)) filterDiamonds = 0;
            } else {
              filterDiamonds = 0;
            }
            
            // Compare the values
            isMatch = (productDiamonds === filterDiamonds);
          }
          // Special handling for band_color
          else if (key === 'band_color') {
            // Check if product has variants with this band color
            if (filters[key] !== undefined && product.variants && product.variants.length > 0) {
              isMatch = product.variants.some(variant => {
                return variant.title && variant.title.toLowerCase().includes(filters[key].toLowerCase())
              }
              );
            } else {
              isMatch = false;
            }
          }
          // Special handling for size which might be undefined
          else if (key === 'size') {
            isMatch = product.metafields.size && 
                     product.metafields.size.toLowerCase() === filters[key].toLowerCase();
          }
          else if (key === 'collection') {
            isMatch = product.metafields.collection && 
                     product.metafields.collection.toLowerCase().includes( filters[key].toLowerCase());
          }
          // Standard string comparison for other fields
          else {
            isMatch = product.metafields[key] && 
                     product.metafields[key].toLowerCase() === filters[key].toLowerCase();
          }
          
          // If this is a required field and it doesn't match, mark allRequiredMatch as false
          if (required && filters[key] && !isMatch) {
            allRequiredMatch = false;
          }
          
          // Increment score if this criterion matches
          if (isMatch) {
            score += criterion.filter_score;
          }
          
          // Store match details for debugging
          matchDetails[key] = {
            filterValue: filters[key],
            productValue: key === 'diamonds_quantity' ? 
                         (product.metafields.diamonds || '0') : 
                         (key === 'band_color' ? 
                           (product.variants && product.variants.length > 0 ? 
                             product.variants.map(v => v.title).join(', ') : 'undefined') :
                           (product.metafields[key] || 'undefined')),
            isMatch: isMatch,
            required: required
          };
        });
        
        return {
          product: product,
          score: score,
          maxScore: maxScore,
          matchDetails: matchDetails,
          allRequiredMatch: allRequiredMatch // Add this property to track if all required fields match
        };
      });
      
      // Filter out products that don't match required fields
      scoredProducts = scoredProducts.filter(product => product.allRequiredMatch);
      
      // Sort products by score (highest first)
      scoredProducts.sort((a, b) => {
        // First sort by score (highest first)
        if (b.score !== a.score) {
          return b.score - a.score;
        }
        
        // calculate diamonds difference
        let aDiamondsDifference = Math.abs(this.currentFilters.diamonds_quantity - a.product.metafields.diamonds);
        let bDiamondsDifference = Math.abs(this.currentFilters.diamonds_quantity - b.product.metafields.diamonds);
        
        if (aDiamondsDifference < bDiamondsDifference) return -1;
        if (aDiamondsDifference > bDiamondsDifference) return 1;

        // If still tied, return the first one
        return 0;
      });
      
      // Get the best match (highest score)
      let bestMatch = scoredProducts.length > 0 ? scoredProducts[0] : null;
      
      if (!bestMatch) {
        return null;
      }
            
      let foundProducts = bestMatch.product;
      let foundVariant = foundProducts.variants[0];
      
      // If we have a band_color filter, try to find a matching variant
      if (filters.band_color && foundProducts.variants && foundProducts.variants.length > 1) {
        const matchingVariant = foundProducts.variants.find(variant => 
          variant.title && variant.title.toLowerCase().includes(filters.band_color.toLowerCase())
        );
        
        if (matchingVariant) {
          foundVariant = matchingVariant;
        }
      }
      foundProducts.variant = foundVariant;
      return foundProducts;
    }
  
    changeSpin(variant = null) {
      if (!variant) return;
      if (window.Sirv) {
        const sirvContainer = document.querySelector('.Sirv');
        try {
          window.Sirv.stop();
          const imageElement = `<img src="${variant.featured_image}" alt="${variant.title}">`;
          sirvContainer.innerHTML = imageElement;
          let sku = variant.sku;
          let sirvelement = `<div data-src="https://giberg.sirv.com/products/${sku}/${sku}.spin" `;
          sirvelement += 'data-options="fit: contain; quality: 90; hdQuality: 90; fullscreen.always: true; ';
          sirvelement += 'contextmenu.enable: true; initialize: hover; autospin.enable: false; autospin.resume: 10000"';
          sirvelement += ` src="${variant.featured_image}"></div>`;
          if (sirvContainer) {
            sirvContainer.innerHTML = sirvelement;
          }
          window.Sirv.on('spin:ready', () => {
            const instance = window.Sirv.getInstance('.Sirv');
            instance.pause();
          });
          window.Sirv.on('spin:error', (error) => {
            console.error('Sirv spin error:', error);
          });
          window.Sirv.on('spin:isinitialized', (isInitialized) => {
            console.log('Sirv is initialized:', isInitialized);
          });
          document.sirvOptions = {
            'autospin.enable': false,
            'autospin.resume': 10000,
            initialize: 'click',
            speed: 0,
          };
          window.Sirv.start();
        } catch (error) {
          console.error('Error updating Sirv spin:', error);
        }
      }
    }
  
    handleBandOptionSelection(event) {
      const button = event.currentTarget.closest('.band-option');
      if (!button || button.disabled) return;
      this.customizerMenu.querySelectorAll('.band-option').forEach((btn) => {
        btn.classList.remove('active');
        btn.dataset.active = 'false';
      });
      button.classList.add('active');
      button.dataset.active = 'true';
      const bandValue = button.dataset.band;
      this.currentFilters = { ...this.currentFilters, band: bandValue };
      const filteredProduct = this.getProductByFilters(this.currentFilters);
      if (filteredProduct) {
        this.currentProductData = filteredProduct;
        this.updateProductNamePrice(null, this.currentProductData.variant?.price);
        this.updateImages(filteredProduct);
        this.updateProductOptions('band', bandValue);
      }
    }
  
    /**
     * on Element Button clicked, modify Elements and update Information
     * @param {*} event 
     * @returns 
     */
    handleBandElementSelection(event) {
      const button = event.currentTarget.closest('.element-option');
      if (!button || button.disabled) return;
      // we must not toggle a boolean button when clicking on next step
      button.classList.toggle('active');
      button.dataset.active = button.classList.contains('active') ? 'true' : 'false';
      const elementValue = button.dataset.active === 'true';
      // addDebugInfo(`elements: ${elementValue}`, 'info');
      this.currentFilters = { ...this.currentFilters, element: elementValue };
      const filteredProduct = this.getProductByFilters(this.currentFilters);
      if (filteredProduct) {
        this.currentProductData = filteredProduct;
        this.updateProductNamePrice(null, this.currentProductData.variant?.price);
        this.updateImages(filteredProduct);
        this.updateProductOptions('elements', elementValue);
      }
    }
  
    compareFilteredProductsWithCurrentProduct() {
      const filters = this.selections;
      this.availableProducts = this.getAvailableProductsBasedOnFilters(filters);
      if (!this.availableProducts) {
        // addDebugInfo('No available products found based on current filters.', 'warning');
        return;
      }
      this.availableProducts.forEach((product) => {
        const differences = this.findDifferences(product, this.currentProductData);
        if (differences.length > 0) {
          differences.forEach((diff) => {
          });
        }
      });
    }
  
    getAvailableProductsBasedOnFilters(filters) {
      if (!this.currentProductData.all_products) {
        return [];
      }
      return Object.keys(this.currentProductData.all_products).map((sku) => {
        return this.currentProductData.all_products[sku];
      });
    }
  
    findDifferences(productA, productB) {
      const differences = [];
      const attributesToCompare = ['collection', 'material', 'size', 'band', 'elements', 'diamonds'];
      attributesToCompare.forEach((attr) => {
        const valueA = productA.metafields?.[attr] || 'N/A';
        const valueB = productB.metafields?.[attr] || 'N/A';
        if (valueA !== valueB) {
          differences.push({
            attribute: attr,
            currentValue: valueB,
            availableValue: valueA,
          });
        }
      });
      return differences;
    }
  
    handleSizeSelection(event) {
      const button = event.currentTarget.closest('.size-option');
      if (!button || button.disabled) return;
  
      const size = button.dataset.size;
      this.selections.size = size;
      this.currentStep = 3;
  
      this.customizerMenu.querySelectorAll('.size-option').forEach((btn) => {
        btn.classList.remove('active');
        btn.dataset.active = 'false';
      });
      button.classList.add('active');
      button.dataset.active = 'true';
      this.currentFilters = { ...this.currentFilters, size };
      // es wird kein produkt gewählt mit getProductByFilters !?
      const filteredProduct = this.getProductByFilters(this.currentFilters);
      if (filteredProduct) {
        this.currentProductData = filteredProduct;
        this.updateProductNamePrice(null, this.currentProductData.variant?.price);
        this.updateImages(filteredProduct);
        this.updateProductOptions('size', size);
      }
    }
  
    updateProductOptions(attribute, value) {
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);
      const filterParamMap = {
        collection: 'collection',
        diamonds: 'diamonds_quantity',
        size: 'size',
        material: 'gold_color',
        band_color: 'band-color',
        band: 'bracelet_size',
        element: 'element',
      };
      let filterParam = filterParamMap[attribute] || attribute;
      params.set(`filter.p.m.${filterParam}`, value);
      url.search = params.toString();
      // window.history.pushState({}, '', url.toString());
      this.selections = this.selections || {};
      this.selections[attribute] = value;
  
      if (!this.currentProductData?.all_products) {
        this.currentProductData.all_products = this.allProducts;
      }

      let matchFilters = {};
      let filterStep = 1;
      Object.keys(this.currentFilters).forEach((key) => {
        if (filterStep <= this.currentStep) {
          matchFilters[key] = this.currentFilters[key];
          if(key === 'band') {
            matchFilters['element'] = this.currentFilters['element'];
          }
        }
        filterStep++;
      });
      
      const matchingProducts = this.currentProductData.all_products.filter((product) => {
        return Object.entries(matchFilters).every(([key, val]) => {
          if (val === undefined) return true;
          if (key === 'band_color') {
            return true;
          }
          if(key === 'element' && typeof val === 'boolean') {
            return product.metafields[key] === val;
          }
          val = val.toString().toLowerCase();
          if (key === 'diamonds_quantity') key = 'diamonds';
          return product.metafields[key]?.toString().toLowerCase() === val;
        });
      });
      this.updateAvailableOptions(matchingProducts);
    }
  
    handleDiamondsSelect(e) {
      const button = e.currentTarget;
      
      // Don't proceed if button is disabled or doesn't exist
      if (!button || button.disabled || button.classList.contains('disabled')) {
        return;
      }
      
      // Update UI to show this button as active
      this.customizerMenu.querySelectorAll('.diamonds-option').forEach((btn) => {
        btn.classList.remove('active');
        btn.dataset.active = 'false';
      });
      button.classList.add('active');
      button.dataset.active = 'true';
      const diamondValue = button.dataset.diamonds;
      // addDebugInfo(`Selected diamonds: ${diamondValue}`, 'info');
      this.currentFilters = { ...this.currentFilters, diamonds_quantity: diamondValue };
      const filteredProduct = this.getProductByFilters(this.currentFilters);
      if (filteredProduct) {
        this.currentProductData = filteredProduct;
        this.updateProductNamePrice(null, this.currentProductData.variant?.price);
        this.updateImages(filteredProduct);
        this.updateProductOptions('diamonds_quantity', diamondValue);
      }
    }
  
    initializeDiamondsFilter() {
      const filterGroups = document.querySelectorAll('.filter-group');
      filterGroups.forEach((group) => {
        if (group.dataset.filterGroup === 'diamonds_quantity') {
          this.diamondsFilter = group;
          // addDebugInfo('Diamonds filter found', 'info');
        }
      });
      if (!this.diamondsFilter) {
        // addDebugInfo('No diamonds filter found in filter groups', 'warning');
      }
      
      // Initialize diamond options based on current product and its collection
      if (this.currentProductData && this.currentProductData.all_products) {
        // Get the current filters
        const currentFilters = {
          collection: this.currentProductData.metafields.collection,
          material: this.currentProductData.metafields.material,
          size: this.currentProductData.metafields.size,
          band: this.currentProductData.metafields.band,
          band_color: this.currentProductData.metafields.band_color,
          element: this.currentProductData.metafields.element
        };
        
        // Find matching products based on current filters (excluding diamonds)
        const matchingProducts = this.currentProductData.all_products.filter(product => {
          return Object.entries(currentFilters).every(([key, val]) => {
            if (!val) return true;
            const normalizedKey = key === 'diamonds_quantity' ? 'diamonds' : key;
            return product.metafields[normalizedKey]?.toString().toLowerCase() === 
                   val.toString().toLowerCase();
          });
        });
        
        // Update diamond options based on matching products
        this.updateDiamondsOptions(matchingProducts);
        
        // addDebugInfo(`Initialized diamonds filter with ${matchingProducts.length} matching products`, 'info');
      }
    }
  
    loadInitialOptions() {
      // Initialize cache
      this.cache = new Map();
      const filters = this.parseFilters();
      this.cache.set('filters', filters);
      const productElement = document.querySelector('[data-product-json]');
      if (productElement) {
        try {
          const productData = JSON.parse(productElement.textContent);
          if (productData.id) {
            // Extract unique band colors from variants
            const bandColors = new Set();
            if (productData.variants?.length > 0) {
              productData.variants.forEach((variant) => {
                if (variant.option1) {
                  bandColors.add(variant.option1);
                }
              });
            }
            this.cache.set('bandColors', [...bandColors]);
          }
          this.cache.set('productData', productData);
        } catch (error) {
          // addDebugInfo(`Error parsing product data: ${error.message}`, 'error');
        }
      }
      this.updateAvailableOptions();
    }
  
    getProductBandColorOptions() {
      const bandColors = [];
      this.currentProductData.variants.forEach((variant) => {
        if (variant.option1) {
          bandColors.push(variant.option1);
        }
      });
      return bandColors;
    }
  
    updateBandColorOptions() {
      const bandColors = this.getProductBandColorOptions();
      const bandColorContainer = this.customizerMenu.querySelector('.band-color-options');
      this.customizerMenu.querySelectorAll('button.band-color-option').forEach((btn) => {
        btn.classList.remove('active');
        btn.dataset.active = 'false';
        btn.addEventListener('click', (e) => this.handleBandColorSelection(e));
      });
      if (bandColorContainer) {
        document.querySelectorAll('.band-color-option').forEach((btn) => {
          btn.disabled = true;
          if (bandColors.map((c) => c.toLowerCase().replace(/\s+/g, '-')).includes(btn.dataset.bandColor.toLowerCase())) {
            const color = btn.dataset.bandColor;
            const variant = this.currentProductData.variants.find(
              (variant) => variant.title.toLowerCase().replace(/\s+/g, '-') === color
            );
            btn.dataset.productId = variant.id;
            btn.dataset.productSku = variant.sku;
            if (variant.id) {
              btn.disabled = false;
            }
          }
        });
      }
    }
  
    handleBandColorSelection(event) {
      const button = event.currentTarget;
      if (!button || button.disabled) return;
      this.customizerMenu.querySelectorAll('.band-color-option').forEach((btn) => {
        btn.classList.remove('active');
        btn.dataset.active = 'false';
      });
      button.classList.add('active');
      button.dataset.active = 'true';
      const colorValue = button.dataset.bandColor;
      const skuValue = button.dataset.productSku;
      const collectionName = this.currentProductData.metafields.collection;
      const goldColor = this.currentProductData.metafields.material;
      const goldColorShort = goldColor ? goldColor.split(' ')[0].toLowerCase() : '';
      const baseSku = skuValue.split('-')[0];
      const sirvContainer = document.querySelector('.Sirv div');
      const variant = this.currentProductData.variants.find(
        (variant) => variant.title.replace(/\s+/g, '-').toLowerCase() === colorValue
      );
      this.currentProductData.variant = variant;
      this.updateProductNamePrice(null, this.currentProductData.variant?.price);
      this.updateImages(this.currentProductData);
      this.updateShareMenuImage(variant);
      if (sirvContainer) {
        sirvContainer.setAttribute('data-src', `https://giberg.sirv.com/products/${skuValue}/${skuValue}.spin`);
        if (window.Sirv) {
          window.Sirv.getInstance('.Sirv').pause();
        }
      }
      this.updateProductOptions('band_color', colorValue);

    }
  
    updateShareMenuImage(variant = null) {
      if (variant == null) {
        console.log('Error: Variant for shared image not found');
        //console.error('Variant for shared image not found');
        return;
      }
      const shareMenuImageElement = document.querySelector('.menu-share .image img');
      if (typeof variant === 'string') {
        let variantId = variant;
        variant = { id: variantId, featured_image: '' };
        if(variantId !== undefined) {
          variant = this.currentProductData.variants.find((variant) => variant.id == variantId);
        }
      } else {
        if (variant.variant) {
          variant = variant.variant;
        }
        if (variant.variants) {
          if (this.currentFilters.collection.toLowerCase() === 'amphora') {
            variant = this.currentProductData.variants.find((variant) => variant.sku.endsWith('-2')).id;
          } else {
            variant = this.currentProductData.variants[0].id;
          }
        }
      }
      let featuredImage = variant.featured_image;
      let imageSource = featuredImage;
      if (featuredImage.src) {
        imageSource = featuredImage.src;
      } else {
        imageSource = `https:${featuredImage}`;
      }

      if (shareMenuImageElement) {
        if (featuredImage) {
          shareMenuImageElement.src = imageSource;
          shareMenuImageElement.srcset = `${imageSource}&width=352 352w, ${imageSource}&width=832 832w, ${imageSource}&width=1200 1200w`;
          shareMenuImageElement.loading = 'eager';
        }
      }
      let downloadImageElement = document.getElementById('save-image-button');
      if (downloadImageElement) {
        downloadImageElement.href = imageSource;
        downloadImageElement.download = this.currentProductData.title+" - "+variant.title+".jpg";
      }
    }
  
    initializeProductList() {
      this.allProducts = this.buildProductList('');
      const allProductsArray = Array.isArray(this.allProducts)
  ? this.allProducts
  : Object.values(this.allProducts || {});

const eldurProducts = allProductsArray.filter((product) => {
  const mf = product?.metafields || {};
  return String(mf.collection || mf.product_collection || '')
    .toLowerCase()
    .includes('eldur');
});

console.log('[ELDUR TEST] product list check: ' + JSON.stringify({
  totalProducts: allProductsArray.length,
  eldurCount: eldurProducts.length,
  eldurTitles: eldurProducts.map((p) => p.title),
  eldurMetafields: eldurProducts.map((p) => ({
    title: p.title,
    collection: p?.metafields?.collection,
    product_collection: p?.metafields?.product_collection,
    material: p?.metafields?.material,
    element: p?.metafields?.element,
    diamonds: p?.metafields?.diamonds
  }))
}, null, 2));
      const filterDataElement = document.getElementById('collection-filter-data');
      if (!filterDataElement) {
        return;
      }
      try {
        let filterGroups = filterDataElement.dataset.filterGroups;
        let filterData = {};
        if (filterGroups.length > 0) {
          filterData = JSON.parse(decodeURIComponent(filterDataElement.dataset.filterGroups));
        }
      } catch (error) {
        // addDebugInfo(`Error parsing filter data: ${error.message}`, 'error');
      }
    }
  
    buildProductList(filterData) {
      const productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
      const allProducts = productData.all_products;
      return allProducts;
    }
  
    getProductSkuByFilterValue(filterKey, filterValue) {
      const productData = this.cache.get('productData');
      if (!productData) return null;
      const variant = productData.variants.find((variant) => variant.option1 === filterValue);
      return variant ? variant.sku : null;
    }
  
    handleMinimizeClick() {
      this.swipeable.classList.remove(`swipeable-${this.heights[this.currentHeightIndex]}`);
      this.minimizeIcon.classList.toggle('active');
      this.currentHeightIndex = this.minimizeIcon.classList.contains('active') ? 0 : 1;
      this.updateMenuState();
    }
  
    handleMaximizeClick() {
      this.swipeable.classList.remove(`swipeable-${this.heights[this.currentHeightIndex]}`);
      this.maximizeIcon.classList.toggle('active');
      this.currentHeightIndex = 2;
      this.updateMenuState();
    }
  
    handleCloseMenuClick() {
      // addDebugInfo('Close menu icon clicked', 'info');
      this.swipeable.classList.remove(`swipeable-${this.heights[this.currentHeightIndex]}`);
      if (this.maximizeIcon.classList.contains('active')) {
        this.maximizeIcon.classList.remove('active');
      }
      this.currentHeightIndex = 1;
      this.updateMenuState();
    }
  
  fetchAvailableProducts() {
  try {
    const el = document.getElementById('customizer-products-json');
    if (!el) throw new Error('customizer-products-json not found');

    this.availableProducts = JSON.parse(el.textContent || '[]');

    console.log('[CUSTOMIZER] loaded from Liquid:', {
      count: this.availableProducts.length
    });
  } catch (error) {
    console.error(error);
    this.availableProducts = [];
  }
}
  
    /**
     * Updates the product name and price in the customizer header
     * @param {string} collectionName - The name of the collection, undefined if unchanged
     * @param {number} price - The price of the product
     */
updateProductNamePrice(collectionName, price) {

  // Detect correct currency based on URL prefix
  let currency = 'CHF';
  let locale = 'de-CH';

  // If user is inside the EU market → euro shop
  if (window.location.pathname.startsWith('/en-eu/')) {
    currency = 'EUR';
    locale = 'de-DE';
  }

  // Update collection name
  if (collectionName !== null) {
    let productName = this.customizerHeader.querySelector('.customizer-product-info>h2');
    productName.textContent = collectionName;
  }

  // Update price with correct formatting
  let productPrice = this.customizerHeader.querySelector('.customizer-price');
  productPrice.textContent = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.floor(price / 100));
}
    setReferrerCookie(referrerUrl) {
      // Set cookie to expire in 30 minutes
      const expirationMinutes = 30;
      const date = new Date();
      date.setTime(date.getTime() + (expirationMinutes * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = "customizer_referrer=" + encodeURIComponent(referrerUrl) + ";" + expires + ";path=/";
    }

    getReferrerFromCookie() {
      const name = "customizer_referrer=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(';');
      for(let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return null;
    }

  }
  
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCustomizer();
  });
